import {
  IVitalListEmptyEntry,
  IVitalListEntry,
  TRecordConfig,
  TVitalDataResponse,
  TVitalDataSearchItem,
  TVitalSettingsResponse,
} from '../../../types/life-id';
import getGraphData from '../get-graph-data';
import { getDetailRowProps } from '../get-detail-row-props';
import {
  BarSegmentChartProps,
  IBarSegmentConfig,
} from '../../../components/bar-segment-chart/bar-segment-chart';
import updateBarChartProps from '../updateBarChartProps';
import getBadgeProps from '../get-badge-props';

/**
 *
 * @param vitalData
 * @param vitalDataSettings
 * @param config TRecordConfig
 */
export default function bmiEntry(
  vitalData: TVitalDataResponse | null,
  vitalDataSettings: TVitalSettingsResponse | null,
  config: TRecordConfig,
): IVitalListEntry | IVitalListEmptyEntry {
  const emptyEntry: IVitalListEmptyEntry = {
    isEmpty: true,
    iconSrc: require('../../../assets/svg/icon-bmi.svg').default,
    title: 'life_id.bmi_index',
    barChartWidgetProps: config.BMI.barchartWidget?.barChartWidgetProps as BarSegmentChartProps,
  };

  if (!vitalDataSettings || !vitalData || !vitalData.bodyMeasure) {
    return emptyEntry;
  }

  const settings = [vitalDataSettings.bodyMeasure];
  const lastRecord = vitalData.bodyMeasure.lastRecord;
  const entry = {
    ...emptyEntry,
    ...getBadgeProps(vitalData.bodyMeasure.lastRecord.source),
    modalType: 'BMI' as const,
    isEmpty: false,
    average: vitalData.bodyMeasure.average || '-',
    status: `life_id:status.${lastRecord.status}`,
    getDetailRowProps: getDetailRowProps(
      settings,
      config.BMI.valueSelectors[0] as keyof TVitalDataSearchItem,
    ),
    summaryChartProps: {
      oneSidedRange: false,
      unit: `units.${config.BMI.unit}`,
      value: lastRecord.bmi || '-',
      ...getGraphData(settings, [lastRecord.bmi]),
    },
    urlPart: config.BMI.urlPart,
    barChartWidgetProps: updateBarChartProps(
      config.BMI.barchartWidget?.config as IBarSegmentConfig,
      lastRecord,
    ),
  };

  return entry;
}
